import Back from "../components/Back";
import DynamicIsland from "../components/DynamicIsland";
import CurrentTime from "../components/CurrentTime";
import './News.css';

function NewsFeed() {
    return (
      <div className="news-container">
      <CurrentTime />
      <DynamicIsland />
        <Back />
        <div className="news-portal">
        <iframe
          src="https://www.towson.edu/news/"
          title="Towson News"
          className="news-iframe"
          scrolling="yes"
        ></iframe>
        </div>
      </div>
    );
  }
  
  export default NewsFeed;
  